export default "__VITE_ASSET__BK99NErQ__$_?component__"